import React, { useEffect, useState } from 'react';

export function KpiCard({ value, label, icon, suffix = '', prefix = '', sub, accent = 'primary' }) {
  const safeEnd =
    value !== undefined && value !== null && !isNaN(value) && isFinite(value)
      ? Math.max(0, Math.round(value))
      : 0;
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (safeEnd === 0) {
      setCount(0);
      return;
    }
    let start = 0;
    const duration = 1200;
    const stepTime = Math.max(Math.floor(duration / safeEnd), 30);
    const timer = setInterval(() => {
      start += Math.ceil(safeEnd / (duration / stepTime));
      if (start >= safeEnd) {
        setCount(safeEnd);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, stepTime);
    return () => clearInterval(timer);
  }, [safeEnd]);

  const accentBorder = {
    primary: 'border-l-prodia-primary',
    success: 'border-l-success',
    warning: 'border-l-warning',
    danger: 'border-l-danger',
    info: 'border-l-info',
  };

  return (
    <div
      className={`bg-prodia-surface border border-prodia-border border-l-4 ${accentBorder[accent] || accentBorder.primary} rounded-xl p-4 shadow-prodia`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-prodia-text-secondary">{label}</span>
        {icon && (
          <div className="w-8 h-8 rounded-lg bg-prodia-background flex items-center justify-center flex-shrink-0">
            <i className={`${icon} text-sm text-prodia-text-muted`} aria-hidden="true" />
          </div>
        )}
      </div>
      <div className="text-2xl font-semibold text-prodia-text-primary tabular-nums">
        {prefix}
        {count.toLocaleString()}
        {suffix}
      </div>
      {sub && <p className="text-xs text-prodia-text-muted mt-1">{sub}</p>}
    </div>
  );
}

export default KpiCard;
